import React from "react";
import Button from "../components/button"

const Start = () => {
return (
	<div className="start">
	<h1>Quizzical</h1>
    <Button text="start" link="./quiz"/>
	</div>
);
};

export default Start;
